const allTranslateHub = `{
  allTranslateHub {
    edges {
      node {
        data {
          seo_h1
          cover_image
          seo_project_content
          seo_project_title
          seo_project_meta_desc
          seo_project_meta_keywords
          slug
          title_x
          category_name
          seo_project_id
          seo_project_create_date
          you_may_also_like {
            cover_image
            slug
            title
            alt
          }
        }
      }
    }
  }
}`;

function translatorHubData(client) {
  return new Promise(function (resolve, reject) {
    client
      .search({
        index: `${process.env.GATSBY_ES_PREFIX}translator_hub`,
        type: "_doc",
        body: {
          query: {
            match_all: {},
          },
        },
        size: 1000,
      })
      .then(
        function (resp) {
          resolve(resp);
        },
        function (err) {
          console.trace(err.message);
        }
      );
  });
}

module.exports = { graphqlQuery: allTranslateHub, data: translatorHubData };
